import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/images/Off2On-min.png";

const Offtoon = () => {
  return (
    <>
    <div className="home-container">
    <Sidebar/>
    <div className="home-content">
      <img
            src={image} // Replace with your image URL
        alt="Clients"
        className="home-image"
      />
    </div>
  </div>
  </>
  )
}

export default Offtoon